export const ADD_ENTITIES = 'ADD_ENTITIES';
export const REMOVE_ENTITIES = 'REMOVE_ENTITIES';

export interface EntitiesActionOptions {
  parent?: { type: string; id: string };
  reset?: boolean;

  [key: string]: any;
}

export interface AddEntitiesAction<T = unknown> {
  type: typeof ADD_ENTITIES;
  service: string;
  data: T;
  options: EntitiesActionOptions;
}

export interface RemoveEntitiesAction {
  type: typeof REMOVE_ENTITIES;
  service: string;
  ids: string | string[];
  options: EntitiesActionOptions;
}

export type EntitiesAction = AddEntitiesAction | RemoveEntitiesAction;

export function addEntities<T>(
  service: string,
  data: T,
  options: EntitiesActionOptions = {},
): AddEntitiesAction<T> {
  return {
    type: ADD_ENTITIES,
    service,
    data,
    options,
  };
}

export function removeEntities(
  service: string,
  ids: string | string[],
  options: EntitiesActionOptions = {},
): RemoveEntitiesAction {
  return {
    type: REMOVE_ENTITIES,
    service,
    ids,
    options,
  };
}
